function monitorCartTotalChange() {
  const targetNode = document.querySelector("[data-cart-price-holder]");
  const checkoutPrice = document.querySelector("[data-cart-total-price]");
  if (!targetNode) {
    console.error("Element [data-cart-price-holder] not found");
    return;
  }

  const config = { childList: true, subtree: true, characterData: true };

  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        // console.log("Cart total changed:", targetNode.textContent);
        // Perform your desired action here

        const finalPrice = document
          .querySelector("[data-cart-total-final]")
          .getAttribute("data-cart-total-final");
        const formattedFinalPrice =
          parseInt(finalPrice) === 0
            ? window.theme.strings.free
            : themeVendor.themeCurrency.formatMoney(
                finalPrice,
                theme.moneyWithCurrencyFormat
              );

        checkoutPrice.textContent = formattedFinalPrice;
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// Call the function to start monitoring
window.addEventListener("theme:cart:loaded", () => monitorCartTotalChange());
// monitorCartTotalChange();
